import React from 'react';
import i18n from 'i18n';
import {
  FormModelProps,
  ModelFormFields,
} from 'modules/environments/interfaces';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import TitleDivider from 'components/TitleDivider';
import SliderField from 'components/SliderField';
import Slider from '@material-ui/core/Slider';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { applyI18n } from 'utils/helpers';
import { FormikErrors } from 'formik';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import { screenFieldsMonitoring } from './formFields';
import styles from './styles';

const useStyles = makeStyles(styles);

interface MonitoringSliderProps {
  label: string;
  sliderKey: keyof (ModelFormFields | FormModelProps);
  fields: GenericFormItem[];
}

interface MonitorSlidersProps {
  values: ModelFormFields | FormModelProps;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  errors: FormikErrors<ModelFormFields | FormModelProps>;
}

const MonitorSliders: React.FC<MonitorSlidersProps> = ({
  values,
  setFieldValue,
  errors,
}) => {
  const classes = useStyles();

  const monitoringSliders: MonitoringSliderProps[] = [
    {
      label: i18n.t('CONNECTIONS_KEY'),
      sliderKey: 'connection_weight',
      fields: [screenFieldsMonitoring[0]],
    },
  ];

  return (
    <Grid container className={classes.slidersRootDiv}>
      <Grid item xs={12}>
        <TitleDivider>{i18n.t('MONITORING_KEY')}:</TitleDivider>
      </Grid>
      {monitoringSliders?.map(slider => (
        <Grid
          item
          xs={12}
          className={classes.sliderItem}
          key={`monitor-slider-${slider?.sliderKey}`}
        >
          <SliderField
            label={slider?.label}
            sliderLabel={`${i18n.t('WEIGHT_KEY')} (${Number(
              values[slider?.sliderKey]
            )}%)`}
            slider={
              <Slider
                value={Number(values[slider?.sliderKey])}
                onChange={(_, value) => setFieldValue(slider?.sliderKey, value)}
                valueLabelDisplay="auto"
                min={0}
                max={100}
              />
            }
            input={
              <GenericForm
                fields={values}
                screenFields={applyI18n(slider.fields, i18n.language)}
                setFieldValue={setFieldValue}
                errors={errors}
              />
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MonitorSliders;
